import * as React from "react";
import { Trans } from "react-i18next";
import { ExperienceTransactionChipPackRewardDetailsFragmentFragment } from "../../../hooks/useXPTransactions/graphql/XPTransactionsFragment.generated";

export const ExperienceTransactionChipPackRewardDetails = ({
  details,
  earnedXP,
  totalXP,
}: {
  details: ExperienceTransactionChipPackRewardDetailsFragmentFragment;
  earnedXP: number;
  totalXP: number;
}) => {
  return (
    <Trans
      i18nKey="xp_transaction.ExperienceTransactionChipPackRewardDetails"
      components={{
        xp: <span className="font-bold" />,
        total: <span className="font-bold" />,
      }}
      values={{ xp: earnedXP, total: totalXP }}
    />
  );
};
